// src/App.js
import React from 'react';
import PageComponent from './Components/PageComponent.js';// Correctly reference the PageComponent

const App = () => {
  return (
    <div className="App">
      <PageComponent />
    </div>
  );
};

export default App;